import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import AdminApp from './admin/AdminApp';

const root = ReactDOM.createRoot(document.getElementById('root'));

// The admin/user back office lives at /admin and /invite/<token>, and the
// public Artist Terms page at /artist-terms shares its bundle. It is a
// separate concern from the public checkout app, with its own auth and no
// customer analytics — mount it directly and skip the Umami init.
const path = window.location.pathname;
const isAdmin = path.startsWith('/admin') || path.startsWith('/invite') || path.startsWith('/artist-terms');

if (isAdmin) {
  root.render(<AdminApp />);
} else {
  // Umami analytics, production-only. Auto-tracks pageviews; custom events
  // fire from analytics.js -> umami.track() throughout the React tree.
  if (process.env.NODE_ENV === 'production' && !document.getElementById('umami-script')) {
      const s = document.createElement('script');
      s.id = 'umami-script';
      s.defer = true;
      s.src = 'https://analytics.olliemail.net/script.js';
      s.setAttribute('data-website-id', '0ffd408b-d119-4243-aa03-0eb8f9a557de');
      document.head.appendChild(s);
  }

  root.render(<App />);
}
